import { Event } from '@tribeplatform/gql-client/types'
import { Alert } from '@tribeplatform/react-ui-kit/Alert'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { useI18n, T } from '../../i18n/index.js'

import { hasRegisteredForEvent } from './utils.js'

interface Props {
  event: Event
}

export const RegistrationConfirmationAlert = ({ event }: Props) => {
  const isRegistered = hasRegisteredForEvent(event)
  const { $t } = useI18n()

  if (isRegistered) {
    return (
      <Alert
        status="success"
        title={$t({
          id: 'Event.Registration.Alert.Title',
          defaultMessage: 'Registration confirmed',
        })}
      >
        <Text className="text-content-on-positive">
          <T
            id="Event.Registration.Alert.Description"
            defaultMessage="You're all set! Event details have been sent to your email."
          />
        </Text>
      </Alert>
    )
  }

  return null
}
